import { createUseStyles } from 'react-jss';
import pillboxBackground from '../../../assets/images/pillbox/pillbox.png';
import morningBackground from '../../../assets/images/pillbox/morning.png';
import forenoonBackground from '../../../assets/images/pillbox/forenoon.png';
import noonBackground from '../../../assets/images/pillbox/noon.png';
import afternoonBackground from '../../../assets/images/pillbox/afternoon.png';
import eveningBackground from '../../../assets/images/pillbox/evening.png';
import nightBackground from '../../../assets/images/pillbox/night.png';

export const useStyles = createUseStyles({
    root: {
        display: 'flex',
    },
    pillBox: {
        backgroundImage: `url(${pillboxBackground})`,
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        backgroundSize: '100%',
        maxWidth: 750,
        aspectRatio: '1274/554',
        width: '50%',
    },
    lid: {
        position: 'absolute',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        inset: 0,
        zIndex: 10,
    },
    morning: {
        backgroundImage: `url(${morningBackground})`,
    },
    forenoon: {
        backgroundImage: `url(${forenoonBackground})`,
    },
    noon: {
        backgroundImage: `url(${noonBackground})`,
    },
    afternoon: {
        backgroundImage: `url(${afternoonBackground})`,
    },
    evening: {
        backgroundImage: `url(${eveningBackground})`,
    },
    night: {
        backgroundImage: `url(${nightBackground})`,
    },
    table: {
        width: '100%',
        height: '100%',
        'thead': {
            height: '100%',
            tr: {
                height: 1,
            },
        },
    },
    col: {
        width: '18%',
        padding: '1.6rem 0.7rem',
        height: 'inherit',
        '&:nth-child(1)': {
            width: '20%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(2)': {
            width: '20%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(3)': {
            width: '15%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(4)': {
            width: '16%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(5)': {
            width: '15%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(6)': {
            width: '15%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
        '&:nth-child(7)': {
            width: '20%',
            paddingRight: '8%',
            '&>*': {
                padding: '0% 0% 0% 0%',
            },
        },
    },
    startWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: '2rem',
    },
    startTrigger: {
        minHeight: 60,
    },
});
